import React, { useRef } from 'react'
import { URL_S3 } from '../../../../config/BaseUrl'

function Images({ photos, fullScreen }) {

  const allItemBody = useRef(null)

  return (
    <div className="video-items section-items" ref={allItemBody} onDoubleClick={e=>fullScreen(allItemBody)} data-title="Double click to open in fullscreen mode">
      <div id="image-gallery" className="carousel slide carousel-fade" data-ride="carousel">
        <div className="carousel-inner">
          {
            photos && photos.length > 0 ?
              photos.map((photo, index) => (
                <div className={`carousel-item ${index === 0 ? 'active' : ''}`} key={`photo-key-${index}`}>
                  <img src={URL_S3 + 'event_gallery/photo/' + photo.event_photo} className="img-fluid" alt="images" />
                </div>
              ))
              :
              <div className="carousel-item active">
                <div className="empty-content">
                  <p className="text-center text-white">There is no items to show</p>
                </div>
              </div>
          }
        </div>
        <a className="carousel-control-prev" href="#image-gallery" role="button" data-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="sr-only">Previous</span>
        </a>
        <a className="carousel-control-next" href="#image-gallery" role="button" data-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="sr-only">Next</span>
        </a>
      </div>
    </div>
  )
}

export default Images
